<template>
  <div class="course_introduce scroll_y hidden_scroll">
    <div class="course_top flex Flexalign FlexBetween">
      <div class="course_contents flex Flexalign">
        <el-image class="course_outline" :src="iconPath('learning_plan.png')"></el-image>
        <div class="ml-10">学习方案</div>
      </div>
    </div>
    <div class="course_top flex Flexalign FlexBetween my-10">
      <div class="">轮次选择</div>
      <el-select
        v-model="planValue"
        placeholder="请选择方案"
        style="width: 100px"
        @change="changeWheel"
      >
        <el-option
          v-for="item in planOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
    </div>
    <div class="course_top flex Flexalign FlexBetween">
      <div class="course_contents flex Flexalign">
        <el-image class="course_outline" :src="iconPath('course_outline.png')"></el-image>
        <div class="ml-10">课程大纲</div>
      </div>
      <!-- <div class="flex Flexalign">
        <div class="auto_text">自动连播</div>
        <el-switch
          v-model="iscontinuous"
          class="ml-2"
          style="--el-switch-on-color: #13ce66"
          @change="changeSwitch"
        />
      </div> -->
    </div>
    <div class="course_introduce_content" ref="content">
      <div class="course_outline" v-for="(item, index) in courseChapterList" :key="index">
        <div class="course_one" :class="[item.isExpanded ? '' : 'course_one_max']">
          <div
            class="course_outline_top flex FlexBetween Flexalign"
            v-if="!$Tools.empty(item.children)"
          >
            <div class="course_outline_top_left flex Flexalign flex-1 toverflow">
              <!-- <el-image class="equal" :src="imgPath('equal.png')"></el-image> -->
              <!-- <div class="course_chapter">{{ item.chapter }}</div> -->
              <div
                class="course_chapter toverflow"
                :class="[
                  selectLearningInfo.parentId == item.chapterId ? 'text_active' : '',
                ]"
              >
                {{ item.chapterName }}
              </div>
              <!-- <div class="course_hour">（{{ item.timeHours }}</div> -->
              <!-- <div class="course_hour">{{ item.chapterNumbers + "节" }}）</div> -->
            </div>
            <div class="cursor_pointer">
              <el-icon color="#999999">
                <ArrowUp v-if="item.isExpanded" @click="retractChapter(item)" />
                <ArrowDown v-else @click="retractChapter(item)" />
              </el-icon>
            </div>
          </div>
          <div v-else>
            <courseTitleList
              :courseOutline="item"
              :courseValue="courseValue"
              :courseChapterId="courseChapterId"
              :onceLoad="true"
              @changeCourseValue="changeCourseValue"
              @changeCourseValueToLearning="changeCourseValueToLearning"
              @showWheel="showWheel"
            >
            </courseTitleList>
          </div>
          <div v-if="item.children">
            <courseTitleList
              :courseOutline="item"
              :courseValue="courseValue"
              :courseChapterId="courseChapterId"
              :onceLoad="true"
              @changeCourseValue="changeCourseValue"
              @changeCourseValueToLearning="changeCourseValueToLearning"
              @showWheel="showWheel"
            >
            </courseTitleList>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import courseTitleList from "./courseTitleList.vue";
export default {
  name: "GjkcH5CourseOutline",
  props: {
    courseId: {},
    courseDetail: {},
  },
  components: {
    courseTitleList,
  },
  computed: {
    ...mapState({
      selectLearningInfo: (state) => state.learning.selectLearningInfo,
      courseScheme: (state) => state.learning.courseScheme,
      selectedChapterInfo: (state) => state.learning.selectedChapterInfo,
      studyChapter: (state) => state.learning.studyChapter,
      studyPreviousChapter: (state) => state.learning.studyPreviousChapter,
    }),
  },
  watch: {
    studyChapter: {
      handler() {
        let currentIndex = this.findPhasePosition(
          this.courseChapterList,
          this.selectLearningInfo.chapterId,
          this.selectLearningInfo.phaseId
        );
        let phaseInfo = this.getPhaseByIndex(this.courseChapterList, currentIndex);
        if (!this.$Tools.empty(phaseInfo)) {
          // 此处再加上视频开放时间
          if (!this.$Tools.empty(phaseInfo.position)) {
            if (!this.$Tools.empty(phaseInfo.position.chapterNode)) {
              let info = phaseInfo.position.chapterNode;
              // 新增判断，判断起始时间是否配置，配置起始时间需判断是否在该时间段，若在该时间段才可切换，否则不可以切换
              if (info.openEndTime && info.openBeginTime) {
                const startTime = new Date(info.openBeginTime).getTime();
                const endTime = new Date(info.openEndTime).getTime();
                const nowTime = new Date().getTime();
                if (nowTime >= startTime && nowTime < endTime) {
                  console.log("");
                } else {
                  this.$Dialog.toast("下一章节阶段视频未到开放时间，请查看课表", {
                    type: "warning",
                  });
                  return;
                }
              }
              // 若只配置开始时间
              if (info.openBeginTime && !info.openEndTime) {
                const startTime = new Date(info.openBeginTime).getTime();
                const nowTime = new Date().getTime();
                if (nowTime < startTime) {
                  this.$Dialog.toast("下一章节阶段视频未到开放时间，请查看课表", {
                    type: "warning",
                  });
                  return;
                }
              }
              // 若只配置结束时间
              if (info.openEndTime && !info.openBeginTime) {
                const endTime = new Date(info.openEndTime).getTime();
                const nowTime = new Date().getTime();
                if (nowTime > endTime) {
                  this.$Dialog.toast("下一章节阶段视频未到开放时间，请查看课表", {
                    type: "warning",
                  });
                  return;
                }
              }
            }
          }
          // 若下一章节阶段的五步都是未开启的状态，那么不做学习章节的切换
          if (
            phaseInfo.phase.inputEnabled == 0 &&
            phaseInfo.phase.outputEnabled == 0 &&
            phaseInfo.phase.passEnabled == 0 &&
            phaseInfo.phase.wrongEnabled == 0 &&
            phaseInfo.phase.finalEnabled == 0
          ) {
            this.$Dialog.toast(
              "下一章节阶段未配置五步信息，请等待老师配置章节资源后再学习",
              { type: "warning" }
            );
            return;
          }
          this.changeCourseValueToLearning(
            phaseInfo.chapterId,
            phaseInfo.phase?.phaseId,
            undefined
          );
        } else {
          console.log("未找到下一章节阶段信息");
        }
      },
    },
    studyPreviousChapter: {
      handler() {
        let currentIndex = this.findPhasePosition(
          this.courseChapterList,
          this.selectLearningInfo.chapterId,
          this.selectLearningInfo.phaseId
        );
        let phaseInfo = {};
        if (currentIndex != 0) {
          phaseInfo = this.getPhaseByIndex(this.courseChapterList, currentIndex - 2); // 此处如果都没有目录的情况下可能上一章节阶段是-1
        } else {
          this.$Dialog.toast("暂无上一章节阶段信息", { type: "warning" });
          return;
        }
        if (!this.$Tools.empty(phaseInfo)) {
          // 此处再加上视频开放时间
          if (!this.$Tools.empty(phaseInfo.position)) {
            if (!this.$Tools.empty(phaseInfo.position.chapterNode)) {
              let info = phaseInfo.position.chapterNode;
              // 新增判断，判断起始时间是否配置，配置起始时间需判断是否在该时间段，若在该时间段才可切换，否则不可以切换
              if (info.openEndTime && info.openBeginTime) {
                const startTime = new Date(info.openBeginTime).getTime();
                const endTime = new Date(info.openEndTime).getTime();
                const nowTime = new Date().getTime();
                if (nowTime >= startTime && nowTime < endTime) {
                  console.log("");
                } else {
                  this.$Dialog.toast("上一章节阶段视频未到开放时间，请查看课表", {
                    type: "warning",
                  });
                  return;
                }
              }
              // 若只配置开始时间
              if (info.openBeginTime && !info.openEndTime) {
                const startTime = new Date(info.openBeginTime).getTime();
                const nowTime = new Date().getTime();
                if (nowTime < startTime) {
                  this.$Dialog.toast("上一章节阶段视频未到开放时间，请查看课表", {
                    type: "warning",
                  });
                  return;
                }
              }
              // 若只配置结束时间
              if (info.openEndTime && !info.openBeginTime) {
                const endTime = new Date(info.openEndTime).getTime();
                const nowTime = new Date().getTime();
                if (nowTime > endTime) {
                  this.$Dialog.toast("上一章节阶段视频未到开放时间，请查看课表", {
                    type: "warning",
                  });
                  return;
                }
              }
            }
          }
          // 若下一章节阶段的五步都是未开启的状态，那么不做学习章节的切换
          if (
            phaseInfo.phase.inputEnabled == 0 &&
            phaseInfo.phase.outputEnabled == 0 &&
            phaseInfo.phase.passEnabled == 0 &&
            phaseInfo.phase.wrongEnabled == 0 &&
            phaseInfo.phase.finalEnabled == 0
          ) {
            this.$Dialog.toast(
              "上一章节阶段未配置五步信息，请等待老师配置章节资源后再学习",
              { type: "warning" }
            );
            return;
          }
          this.changeCourseValueToLearning(
            phaseInfo.chapterId,
            phaseInfo.phase?.phaseId,
            undefined
          );
        } else {
          this.$Dialog.toast("暂无上一章节阶段信息", { type: "warning" });
        }
      },
    },
  },

  data() {
    return {
      courseList: [],
      iscontinuous: false,
      courseChapterList: [],
      courseValue: "",
      allCourseList: [],
      allPlayerCourseList: [],
      planValue: "1",
      planOptions: [],
      schemeList: [],
      schemeId: "",
      courseChapterId: "",
      phaseIdIndex: 1,
      isToastCooling: false, // 最后一次弹出时间戳
    };
  },

  mounted() {
    // this.getCourseChapter();
    // 获取轮次
    this.getRoundDict();
  },

  methods: {
    // getSchemeByCourseId() {
    //   this.$Api.course
    //     .getSchemeByCourseId(this.courseId)
    //     .then((res) => {
    //       this.schemeList = res.data.data;
    //       this.schemeId = res.data.data[0]?.schemeId;
    //       // 获取章节列表
    //       this.getCourseChapter();
    //     })
    //     .catch(() => {});
    // },
    getRoundDict() {
      this.$Api.course
        .getRoundDict()
        .then((res) => {
          for (var key in res.data.data) {
            this.planOptions.push({ label: res.data.data[key], value: key });
          }
          this.$store.commit("learning/setCourseRound", this.planOptions[0].value);
          // 获取方案
          // this.getSchemeByCourseId();
          // 获取章节列表
          this.getCourseChapter();
        })
        .catch(() => {});
    },
    changeWheel(info) {
      this.planValue = info;
      this.getCourseChapter();
    },
    // 是否自动播放
    changeSwitch() {
      this.$store.commit("learning/changeIsContinuous", this.iscontinuous);
    },
    // 收起课程大纲
    retractChapter(info) {
      info.isExpanded = !info.isExpanded;
    },
    // 获取课程章节列表
    getCourseChapter() {
      this.allPlayerCourseList = [];
      this.$Api.course
        .getCourseChapterNew({
          courseId: this.courseId,
          roundId: this.planValue,
          schemeId: this.courseScheme,
        })
        .then((res) => {
          this.allCourseList = res.data.data;
          let courseChapterList = res.data.data;
          this.courseChapterList = this.$Tree.handleTree(
            courseChapterList,
            "chapterId",
            "parentId"
          );
          // 统计时长
          this.courseChapterList = this.getAllChildren(this.courseChapterList);
          this.addWheelToLeafNodes(this.courseChapterList);
          // 遍历出所有章节（最终）
          this.traverseArray(this.courseChapterList);
          setTimeout(() => {
            this.$store.commit("learning/setCourseChapterList", this.allPlayerCourseList);
            // 默认展示第一个章节视频
            // this.$store.commit(
            //   "learning/setSelectLearningInfo",
            //   this.allPlayerCourseList[0]
            // );
            // 此处默认先展开第一个章节
            if (!this.allPlayerCourseList[0]) {
              // this.$Dialog.toast("当前轮次/方案未配置章节，请联系客服人员",{type:"warning"});
              this.$store.commit("learning/setSelectLearningInfo", {});
              return;
            }
            // this.showWheel(
            //   this.courseChapterList,
            //   this.allPlayerCourseList[0]?.chapterId
            // );
            // 默认展示第一个章节视频(后期需优化根据学习到的章节id以及阶段id去展示)
            // this.changeCourseValueToLearning(this.allPlayerCourseList[0]?.chapterId,this.allPlayerCourseList[0].phaseVoList[0]?.phaseId);
            // 获取课程最新学习章节信息
            this.getMyCourseProgress();
          }, 500);
          // this.$emit('getCourseVideo',this.courseChapterList[0]);
        })
        .catch(() => {
          // this.$Dialog.toast(err.data.message, { type: "error" });
        });
    },

    // 自配四轮
    addWheelToLeafNodes(nodes) {
      for (const node of nodes) {
        // 判断是否是叶子节点（children为null或空数组）
        const isLeaf =
          !node.children || (Array.isArray(node.children) && node.children.length === 0);

        if (isLeaf) {
          // 给叶子节点添加wheel属性
          node.wheel = false; // 或自定义属性值
          // (node.wheelList = [
          //   { label: "导入", value: 1 },
          //   { label: "理解", value: 2 },
          //   { label: "变式", value: 3 },
          //   { label: "综合", value: 4 },
          // ]),
          //   (node.wheelStage = 1);
        } else if (Array.isArray(node.children)) {
          // 递归处理子节点
          this.addWheelToLeafNodes(node.children);
        }
      }
    },
    // 四轮显示
    showWheel(nodes, chapterId) {
      // 只有章节的时候没有children直接取反值
      if (this.$Tools.empty(nodes)) {
        let selectedChapterInfo = this.courseChapterList.find(
          (item) => item.chapterId == chapterId
        );
        selectedChapterInfo.wheel = !selectedChapterInfo.wheel;
        console.log(selectedChapterInfo);
        return;
      }
      for (const node of nodes) {
        // 判断是否是叶子节点（children为null或空数组）
        const isLeaf =
          !node.children || (Array.isArray(node.children) && node.children.length === 0);

        if (isLeaf) {
          if (node.chapterId == chapterId) {
            // node.wheel = true;
            node.wheel = !node.wheel;
          } else {
            node.wheel = false;
          }
        } else if (Array.isArray(node.children)) {
          // 递归处理子节点
          this.showWheel(node.children, chapterId);
        }
      }
    },

    // 做递归统计
    getAllChildren(arr) {
      // 递归计算单个节点的总时长
      const calc = (node) => {
        let total = node.chapterResource.videoDuration || 0; // 基础值
        let totalChapter = 0; // 统计章节数
        if (node.children?.length) {
          // 有子节点时递归
          total += node.children.reduce((sum, child) => sum + calc(child).total, 0);
          totalChapter += node.children.length;
        }
        return {
          total,
          totalChapter,
        };
      };
      // 处理第一层并返回新数组
      return arr.map((item) => ({
        ...item, // 保留原有属性
        totalSecond: calc(item).total, // 添加统计结果
        totalChapter: calc(item).totalChapter,
        isExpanded: true, // 第一层默认展开状态
      }));
    },
    // 查找阶段位置的核心方法
    findPhasePosition(treeData, targetChapterId, targetPhaseId) {
      let globalCounter = 0; // 全局阶段计数器
      let foundIndex = -1; // 目标阶段位置

      // 深度优先遍历函数
      function dfs(nodes) {
        for (const node of nodes) {
          // 关键判断：是否为包含阶段列表的叶子节点
          const isLeafWithPhases = !Array.isArray(node.children) && node.phaseVoList;

          if (isLeafWithPhases) {
            // 双重验证：章节ID匹配且包含阶段列表
            if (node.phaseVoList) {
              for (const phase of node.phaseVoList) {
                globalCounter++; // 全局序号递增
                // 双重匹配：章节ID和阶段ID同时匹配
                if (node.chapterId == targetChapterId && phase.phaseId == targetPhaseId) {
                  foundIndex = globalCounter;
                  return true; // 找到后立即终止
                }
              }
            }
          } else if (Array.isArray(node.children)) {
            // 递归遍历子节点
            if (dfs(node.children)) return true;
          }
        }
        return false;
      }

      // 执行遍历
      if (Array.isArray(treeData) && treeData.length > 0) {
        dfs(treeData);
      }
      return foundIndex;
    },
    // 树形结构根据顺序索引查找阶段信息
    getPhaseByIndex(treeData, targetIndex) {
      let globalCounter = 0; // 维护与之前完全一致的计数逻辑
      let result = null; // 存储找到的阶段对象

      function dfs(nodes) {
        for (const node of nodes) {
          // 保持与原函数相同的叶子节点判断逻辑
          const isLeafWithPhases = !Array.isArray(node.children) && node.phaseVoList;

          if (isLeafWithPhases) {
            if (node.phaseVoList) {
              for (const phase of node.phaseVoList) {
                // 当计数器达到目标索引时捕获信息
                if (globalCounter === targetIndex) {
                  result = {
                    chapterId: node.chapterId,
                    phase: { ...phase }, // 返回阶段副本避免引用污染
                    position: {
                      chapterNode: node,
                      phaseIndex: globalCounter,
                    },
                  };
                  return true; // 找到后立即终止
                }
                globalCounter++; // 严格保持与原函数相同的计数顺序
              }
            }
          } else if (Array.isArray(node.children)) {
            if (dfs(node.children)) return true;
          }
        }
        return false;
      }

      if (Array.isArray(treeData) && targetIndex >= 0) {
        dfs(treeData);
      }
      return result; // 未找到时返回null
    },
    // 根据章节/阶段id查找信息
    findPhaseInfo(treeData, targetChapterId, targetPhaseId) {
      let globalCounter = 0;
      let result = {
        index: -1,
        chapterNode: null,
        phaseObj: null,
      };

      function dfs(nodes) {
        for (const node of nodes) {
          // 优化判断逻辑：更精准的叶子节点判断
          const isLeafWithPhases =
            (!node.children || node.children.length === 0) &&
            node.phaseVoList?.length > 0;

          if (isLeafWithPhases) {
            for (const phase of node.phaseVoList) {
              globalCounter++;
              // 添加严格类型检查
              if (
                Number(node.chapterId) === Number(targetChapterId) &&
                Number(phase.phaseId) === Number(targetPhaseId)
              ) {
                result = {
                  index: globalCounter,
                  chapterNode: { ...node, phaseVoList: undefined }, // 移除冗余数据
                  phaseObj: phase,
                };
                return true;
              }
            }
          } else if (node.children?.length) {
            if (dfs(node.children)) return true;
          }
        }
        return false;
      }

      if (Array.isArray(treeData)) {
        dfs(treeData);
      }
      return result;
    },
    // 给章节下阶段配置是否可点击开始学习按钮字段
    addGlobalPhaseOrder(treeData) {
      const dfs = (nodes) => {
        for (const node of nodes) {
          const isLeafWithPhases = !Array.isArray(node.children) && node.phaseVoList;

          if (isLeafWithPhases && node.phaseVoList) {
            // 关键修改：重新赋值 phaseVoList
            node.phaseVoList = node.phaseVoList.map((item) => {
              const phaseIdIndex = this.findPhasePosition(
                this.courseChapterList,
                node.chapterId,
                item.phaseId
              );

              // 返回新对象（保留原属性）
              return {
                ...item,
                showLearningBtn:
                  phaseIdIndex <= this.phaseIdIndex + 1 ||
                  this.courseDetail.learningStyle != 2,
              };
            });
          } else if (Array.isArray(node.children)) {
            dfs(node.children); // 移除条件判断，保证完整遍历
          }
        }
      };

      if (Array.isArray(treeData) && treeData.length > 0) {
        dfs(treeData);
      }
    },

    // 输出最后一个children
    traverseArray(array) {
      array.forEach((item) => {
        if (item.children) {
          // 如果当前项有children，则递归调用该函数
          this.traverseArray(item.children);
        } else {
          // 处理当前项，例如打印出来
          this.allPlayerCourseList.push(item);
          return item;
        }
      });
    },
    // 选中课程
    changeCourseValue(chapterId) {
      this.courseValue = chapterId;
    },

    // 获取课程最新学习章节
    getMyCourseProgress() {
      // 如果selectedChapterInfo不为空，则是从详情页跳转来的，此时不要初始化获取章节最新进度
      if (!this.$Tools.empty(this.selectedChapterInfo)) return;
      this.$Api.course
        .getMyCourseProgress({ courseId: this.courseId })
        .then((res) => {
          // 判断是否有章节Id，没有证明第一次学习，默认展示第一个章节的第一阶段
          if (!res.data.data.chapterId) {
            this.changeCourseValueToLearning(
              this.allPlayerCourseList[0]?.chapterId,
              this.allPlayerCourseList[0].phaseVoList[0]?.phaseId,
              true
            );
            // 判断当前学习进度在树形结构中排列结果
            this.phaseIdIndex = this.findPhasePosition(
              this.courseChapterList,
              this.allPlayerCourseList[0]?.chapterId,
              this.allPlayerCourseList[0].phaseVoList[0]?.phaseId
            );
            // 第一次学习默认展开第一章节阶段
            this.showWheel(
              this.courseChapterList,
              this.allPlayerCourseList[0]?.chapterId
            );
          } else {
            this.changeCourseValueToLearning(
              res.data.data.chapterId,
              res.data.data.phaseId,
              true
            );
            this.phaseIdIndex = this.findPhasePosition(
              this.courseChapterList,
              res.data.data.chapterId,
              res.data.data.phaseId
            );
            // 展示当前正在学习的章节阶段
            this.showWheel(this.courseChapterList, res.data.data.chapterId);
          }
          this.addGlobalPhaseOrder(this.courseChapterList);
        })
        .catch(() => {});
    },

    // 选中课程开始学习
    changeCourseValueToLearning(chapterId, wheelId, flag) {
      // 避免重复调用
      if (this.isChangingCourse) return;
      this.isChangingCourse = true;

      try {
        // 重置（已提交试卷的情况）
        this.$store.commit("learning/setIsHomeworkBack", false);
        this.$store.commit("learning/setIsChallengeBack", false);
        this.courseValue = wheelId;
        // flag为true表示初次进入/不是闯关模式无需判断学习进度（其余情况切换章节需要调接口获取最新学期情况）
        if (flag || this.courseDetail.learningStyle != 2) {
          this.courseChapterId = chapterId;
          let courseInfo = this.allCourseList.filter(
            (item) => item.chapterId == chapterId
          );
          if (courseInfo[0]?.phaseVoList) {
            if (courseInfo[0]?.phaseVoList.length) {
              let selectSchemeInfo = courseInfo[0]?.phaseVoList.filter(
                (item) => item.phaseId == wheelId
              );
              // 查找不到存在阶段被停用的情况
              if (this.$Tools.empty(selectSchemeInfo)) {
                // 该情况默认恢复到第一个章节的第一个阶段
                this.changeCourseValueToLearning(
                  this.allPlayerCourseList[0]?.chapterId,
                  this.allPlayerCourseList[0].phaseVoList[0]?.phaseId
                );
                return;
              }
              // 若下一章节阶段的五步都是未开启的状态，那么不做学习章节的切换
              if (
                selectSchemeInfo[0].inputEnabled == 0 &&
                selectSchemeInfo[0].outputEnabled == 0 &&
                selectSchemeInfo[0].passEnabled == 0 &&
                selectSchemeInfo[0].wrongEnabled == 0 &&
                selectSchemeInfo[0].finalEnabled == 0
              ) {
                this.$Dialog.toast(
                  "下一章节阶段未配置五步信息，请等待老师配置章节资源后再学习",
                  { type: "warning" }
                );
                return;
              }
              // 此处再新增一个逻辑，切换章节判断下一章节的开始学习按钮是否开启，若未开启自动开启(此处直接将当前阶段id变为下一章节阶段索引再触发下配置开始按钮方法)
              let nextCurrentIndex = this.findPhasePosition(
                this.courseChapterList,
                selectSchemeInfo[0].chapterId,
                selectSchemeInfo[0].phaseId
              );
              // let nextPhaseInfo = this.getPhaseByIndex(this.courseChapterList, nextCurrentIndex);
              // console.log(nextPhaseInfo, 66666);
              // console.log(this.courseChapterList, 77777);
              // 下一索引大于当前学习进度的索引才改变值
              if (nextCurrentIndex >= this.phaseIdIndex) {
                this.phaseIdIndex = nextCurrentIndex;
              }
              this.addGlobalPhaseOrder(this.courseChapterList);
              this.$store.commit("learning/setSelectLearningInfo", selectSchemeInfo[0]);
            }
          }
        } else {
          this.getMyCourseProgressVerify(chapterId, wheelId);
        }
      } finally {
        this.isChangingCourse = false;
      }

      // this.$emit("getCourseVideo", courseInfo[0]?.chapterResource?.previewVideoPath);
      // this.$store.commit("learning/setSelectLearningInfo", courseInfo[0]);
    },
    // 验证最新
    getMyCourseProgressVerify(chapterId, wheelId) {
      this.$Api.course
        .getMyCourseProgress({ courseId: this.courseId })
        .then((res) => {
          let currentChapterInfo = res.data.data;
          // 点击的阶段在树形结构中的顺序
          let clickedChapterIndex = this.findPhasePosition(
            this.courseChapterList,
            chapterId,
            wheelId
          );
          // 当前的阶段在树形结构中的顺序
          let currentChapterIndex = this.findPhasePosition(
            this.courseChapterList,
            currentChapterInfo.chapterId,
            currentChapterInfo.phaseId
          );
          // 此处加个判断若两个章阶段索引差大于1则肯定不能学习（点击的阶段索引 > 当前的阶段）开始学习按钮已经限制仅展示下一个章节阶段有，其他无
          if (
            currentChapterInfo.studyStatus == 2 ||
            clickedChapterIndex <= currentChapterIndex
          ) {
            // 学习阶段/章节切换成功
            this.changeCourseValueToLearning(chapterId, wheelId, true);
            // 此处添加主动记录当前学习进度（更新学习进度，仅点击当前章节阶段后的才记录，否则会刷新之前的学习进度）
            if (clickedChapterIndex > currentChapterIndex) {
              // 查找当前点击阶段的信息
              let phaseInfo = this.findPhaseInfo(
                this.courseChapterList,
                chapterId,
                wheelId
              );
              if (phaseInfo.chapterResource) {
                this.$Api.learning
                  .recordPhaseProgress({
                    schemeChapterPhaseId: phaseInfo.id,
                  })
                  .then(() => {})
                  .catch(() => {});
              }
            }
          } else {
            // this.changeCourseValueToLearning(
            //   currentChapterInfo.chapterId,
            //   currentChapterInfo.wheelId,
            //   true
            // );
            // this.$Dialog.toast("请先完成当前阶段学习", { type: "warning" });
            this.showLockedToast(currentChapterInfo);
          }
        })
        .catch(() => {});
    },
    async showLockedToast(currentChapterInfo) {
      if (this.isToastCooling) return;

      this.isToastCooling = true;
      this.$Dialog.toast("请先完成当前阶段学习", { type: "warning" });
      this.changeCourseValueToLearning(
        currentChapterInfo.chapterId,
        currentChapterInfo.phaseId,
        true
      );

      await new Promise((resolve) =>
        setTimeout(() => {
          this.isToastCooling = false;
          resolve();
        }, 500)
      );
    },
    // 查找结点（深度遍历）
    findChapterByIdIterative(nodes, targetId) {
      if (!Array.isArray(nodes)) return null;

      const stack = [...nodes]; // 初始化栈

      while (stack.length > 0) {
        const node = stack.pop(); // 后进先出 (LIFO)

        if (node.chapterId === targetId) {
          return node;
        }

        // 子节点按原顺序反向入栈，确保正向遍历
        if (Array.isArray(node.children)) {
          for (let i = node.children.length - 1; i >= 0; i--) {
            stack.push(node.children[i]);
          }
        }
      }

      return null;
    },
    // 对比树形结构两个chapterId的先后顺序
    compareChapterOrder(tree, idA, idB) {
      if (!Array.isArray(tree)) return null;

      // 队列结构：[节点, 层级]
      const queue = tree.map((node) => ({ node, depth: 0 }));
      const orderMap = new Map(); // 记录 { id: { depth, index } }

      let foundA = false,
        foundB = false;

      // 广度优先遍历
      while (queue.length > 0 && !(foundA && foundB)) {
        const { node, depth } = queue.shift();
        const currentId = node.chapterId;

        // 记录当前节点顺序（首次出现位置）
        if (!orderMap.has(currentId)) {
          orderMap.set(currentId, { depth, index: orderMap.size });
        }

        // 检查是否找到目标
        if (currentId === idA) foundA = true;
        if (currentId === idB) foundB = true;

        // 子节点入队（深度+1）
        if (Array.isArray(node.children)) {
          node.children.forEach((child) => queue.push({ node: child, depth: depth + 1 }));
        }
      }

      // 获取顺序信息
      const dataA = orderMap.get(idA);
      const dataB = orderMap.get(idB);

      if (!dataA || !dataB) return null; // 任一未找到

      // 层级优先比较
      if (dataA.depth !== dataB.depth) {
        return dataA.depth < dataB.depth ? `${idA}-${idB}` : `${idB}-${idA}`;
      }

      // 同层级按遍历顺序比较
      return dataA.index < dataB.index ? `${idA}-${idB}` : `${idB}-${idA}`;
    },
  },
};
</script>
<style lang="scss" scoped>
.course_introduce {
  // max-height: 550px;
  // overflow: hidden;
  // margin-top: 20px;
  background: #ffffff;
  width: 330px;
  max-height: 584px;
  padding: 10px 20px;
  box-sizing: border-box;
  border-radius: 10px;
  // overflow-y: auto;
  position: relative;

  .course_top {
    .course_contents {
      font-weight: bold;
      font-size: 18px;
      color: #111111;

      .course_outline {
        width: 18px;
        height: 18px;
      }
    }

    :deep(.el-select__wrapper) {
      box-shadow: none;
    }

    :deep(.el-select__wrapper.is-focused) {
      box-shadow: none;
    }

    .auto_text {
      font-size: 14px;
      color: #999999;
      margin-right: 5px;
    }
  }

  .course_introduce_content {
    //   max-height: 500px;
    //   overflow: hidden;

    .course_outline {
      margin-top: 10px;

      .course_one_max {
        max-height: 28px;
        overflow: hidden;
      }

      .course_outline_top {
        .equal {
          width: 28px;
          height: 28px;
        }

        .course_chapter {
          margin-left: 10px;
          // font-weight: bold;
          font-size: 18px;
          color: #333333;
        }

        .text_active {
          color: #13d6aa;
        }

        .course_hour {
          margin-left: 5px;
          font-weight: 400;
          font-size: 16px;
          color: #999999;
        }
      }

      .course_subChapter {
        margin-top: 15px;
        // margin-left: 40px;

        .subChapter_top {
          .subChapter_top_left_subChapter {
            margin-left: 5px;
            color: #333333;
            font-size: 18px;
            // font-weight: 600;
          }
        }

        .subChapterList {
          // margin-top: 10px;

          .subChapterList_one {
            line-height: 40px;
            color: #999999;

            .sub_label {
              white-space: nowrap;
              /* 禁止文本换行 */
              overflow: hidden;
              /* 隐藏溢出的内容 */
              text-overflow: ellipsis;
              /* 显示省略号 */
            }

            .sub_time {
              width: 40px;
            }

            .select_play {
              margin-right: 10px;
              width: 18px;
              height: 18px;
            }

            .btn_learn {
              width: 80px;
              height: 34px;
              background: linear-gradient(90deg, #00d5c2, #00d498);
              border-radius: 17px;
              color: #ffffff;
              line-height: 34px;
              margin-right: 10px;
              text-align: center;
            }
          }

          .active_subChapterList_one {
            background: #fafcff;
            color: #13d6aa;
          }
        }
      }
    }
  }

  .course_introduce_content.expanded {
    max-height: none;
    overflow: visible;
    /* 展开后高度 */
  }

  .more_load {
    width: 100%;
    height: 50px;
    background: #ffffff;
    border-radius: 0px 0px 20px 20px;
    // position: absolute;
    // bottom: 0;
    z-index: 9;
    color: #999999;
  }
}
</style>
